import { UrlQueryParams } from '@provision/portal-routes';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useMessageDeepLinkParam(): {
  targetMessageId: string | null;
  clearTargetParam: () => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const targetMessageId = searchParams.get(UrlQueryParams.messageId) || null;

  // replace, not push: a refresh must not replay the jump, and Back must not land on it
  const clearTargetParam = useCallback(() => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        next.delete(UrlQueryParams.messageId);
        return next;
      },
      { replace: true },
    );
  }, [setSearchParams]);

  return { targetMessageId, clearTargetParam };
}
